import React from "react";
import {Table} from "react-bootstrap";
import {price, count} from "../../../../utils/formatter";

export function OrderProductsTable(props) {
  const {products} = props;
  const total = products.reduce((accu, prod) => {
    accu.price += prod.saleAmt;
    accu.count += prod.ordQty;
    return accu;
  }, {price: 0, count: 0});

  return (
    <Table className="table-head-info" bordered responsive variant="light-info">
      <thead>
      <tr className="text-center">
        <th>No</th>
        <th>상품코드</th>
        <th>상품명</th>
        <th>선택 옵션</th>
        <th>판매가</th>
        <th>수량</th>
      </tr>
      </thead>

      <tbody>
      {products.map(product => (
        <tr>
          <td className="text-center">{product.no}</td>
          <td className="text-center">{product.goodsNo}</td>
          <td className="text-left">{product.goodsNm}</td>
          <td className="text-left">{product.optNm}</td>
          <td className="text-right">{price(product.saleAmt)}</td>
          <td className="text-center">{count(product.ordQty)}</td>
        </tr>
      ))}

      <tr className="bg-light-light font-weight-bolder">
        <td colSpan={4} className="text-right">총</td>
        <td className="text-right">{price(total.price)}</td>
        <td className="text-center">{count(total.count)}</td>
      </tr>
      </tbody>
    </Table>
  );
}



